import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const GeometricShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390.5 216",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 216h316.1L390.5 0h-316z"
    })
  });
};

export { GeometricShape };
//# sourceMappingURL=GeometricShape.js.map
